export enum MCPSidebarTabs {
  ACCESS = 'access',
  ACTIVITY = 'activity',
  AGENTS = 'agents',
  APPS = 'apps',
  DIRECTORY = 'directory',
  MY_CONNECTIONS = 'my-connections',
  MY_AGENTS = 'my-agents',
  PROFILES = 'profiles',
  SHADOW_AI = 'shadow-ai',
  TUNNELS = 'tunnels'
}

export enum GlobalSidebarTabs {
  DOCUMENTATION = 'documentation',
  SETTINGS = 'settings'
}

export type SidebarTabs =
  // MCP Tabs
  | MCPSidebarTabs
  // Global Tabs
  | GlobalSidebarTabs;
